


































import isPlainObject from 'lodash/isPlainObject'
import { mapGetters } from 'vuex'
import { trackEvent, SEGMENT_EVENTS } from '@/analytics/segment'

function flattenFilterValues(filters) {
  return Object.entries(filters).reduce((result, [filter, value]) => {
    if (!value && value !== 0) result[filter] = undefined
    else if (isPlainObject(value))
      Object.entries(value).forEach(([key, value]) => {
        result[key] = value || undefined
      })
    else result[filter] = value
    return result
  }, {})
}

export default {
  props: {
    initialValues: {
      type: Object,
      default: () => {}
    }, // using internal state management is optional, it can also be stored in parent
    display: {
      type: String,
      validator: val => ['flex', 'grid'].includes(val), // the 'grid' option will apply plankton grid, 2 columns are reserved for the apply button
      default: 'flex'
    }
  },
  data() {
    return {
      values: null, // internal state is passed to slot and can be updated by child components
      filtersOpen: false
    }
  },
  computed: {
    ...mapGetters(['isBannerOpen']),
    filterClasses() {
      return {
        'filter-group': true,
        'filters-flex': this.display === 'flex',
        'plankton-grid': this.display === 'grid'
      }
    },
    filtersRowClasses() {
      return {
        'filters-row--open': this.filtersOpen,
        'filters-row--with-banner': this.isBannerOpen
      }
    }
  },
  watch: {
    initialValues: {
      handler() {
        this.values = this.initialValues
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    onClickToggle() {
      this.filtersOpen = !this.filtersOpen
    },
    onClickApply() {
      this.$emit('click-apply') // event can be used if state is managed in parent
      this.updateFilters()
      this.onClickToggle()
    },
    updateFilters() {
      const filterValues = {
        pickupRange: this.values.pickupRange,
        dropOffRange: this.values.dropOffRange,
        vehicleType: this.values.vehicleType,
        reference: this.values.reference,
        pickupPlaceId: this.values.pickupLocation && this.values.pickupLocation.placeId,
        pickupLocationName:
          this.values.pickupLocation && this.values.pickupLocation.description,
        dropOffPlaceId:
          this.values.dropOffLocation && this.values.dropOffLocation.placeId,
        dropOffLocationName:
          this.values.dropOffLocation && this.values.dropOffLocation.description,
        requiredActions: this.values.requiredActions,
        maxWeight: this.values?.loadDimensions?.weight?.maxWeight,
        minWeight: this.values?.loadDimensions?.weight?.minWeight,
        maxHeight: this.values?.loadDimensions?.maxHeight,
        maxWidth: this.values?.loadDimensions?.maxWidth,
        maxLength: this.values?.loadDimensions?.maxLength,
        pickupRadius: this.values?.pickupRadius,
        dropOffRadius: this.values?.dropOffRadius
      }
      const filters = flattenFilterValues(filterValues)
      const query = { ...this.$route.query, ...filters }
      this.$router.push({ query })

      trackEvent(SEGMENT_EVENTS.MARKETPLACE_SEARCHING_FOR_OFFERS_FORM, query)
    }
  }
}
